const gtmEvents = {
  MENU_LOGO: 'menu_logo',
  MENU_ABOUT_US: 'menu_about_us',
  MENU_REBATES: 'menu_rebates',
  MENU_BLOG: 'menu_blog',
  MENU_PRODUCT: 'menu_product',
  MENU_EV_CHARGER: 'menu_ev_charger',
  MENU_SOFTWARE: 'menu_software',
  MENU_CALCULATOR: 'menu_calculator',
  MENU_CONTACT_US: 'menu_contact_us',
  CLICK_PHONE_MENU: 'click_phone_menu',
  STAY_UPDATED: 'stay_updated',
  LEAD_REQUEST_A_CALLBACK: 'lead_request_a_callback',
  LEAD_FULL_NAME: 'lead_full_name',
  LEAD_FORM_EMAIL: 'lead_form_email',
  LEAD_FORM_PHONE: 'lead_form_phone',
  LEAD_FORM_COMMENT: 'lead_form_comment',
  HARDWARE_BUTTON_MID: 'hardware_button_mid',
  SOFTWARE_BUTTON_MID: 'software_button_mid',
  TOP_BUTTON_FREE_CONSULTATION: 'top_button_free_consultation',
  FAQ: 'faq',
  SELECT_CHARGE_KWH: 'select_charge_kwh',
  SELECT_CHARGE_HOUR: 'select_charge_hour',
  SEND_DATA_CALCULATOR: 'send_data_calculator',
  REBATE: 'rebate',
  PHONE_FREE_CONSULTATION: 'phone_free_consultation',
  EVCHARGER_CALLBACK: 'evcharger_callback',
  EVCHARGER_TIME_DISTANCE: 'evcharger_time_distance',
  EVCHARGER_REQUEST_CALLBACK: 'evcharger_request_callback',
  SLIDER_REQUEST_DETAILS: 'slider_request_details',
};

const gtmTrack = (event: string, params: Record<string, any> = {}) => {
  if (typeof window !== 'undefined') {
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push({ ...params, event });
  }
};

export const triggerMenuLogo = () => {
  gtmTrack(gtmEvents.MENU_LOGO);
};

export const triggerMenuAboutUs = () => {
  gtmTrack(gtmEvents.MENU_ABOUT_US);
};

export const triggerMenuRebates = () => {
  gtmTrack(gtmEvents.MENU_REBATES);
};

export const triggerMenuProduct = () => {
  gtmTrack(gtmEvents.MENU_PRODUCT);
};

export const triggerMenuEvCharger = () => {
  gtmTrack(gtmEvents.MENU_EV_CHARGER);
};

export const triggerMenuSoftware = () => {
  gtmTrack(gtmEvents.MENU_SOFTWARE);
};

export const triggerMenuBlog = () => {
  gtmTrack(gtmEvents.MENU_BLOG);
};

export const triggerMenuCalculator = () => {
  gtmTrack(gtmEvents.MENU_CALCULATOR);
};

export const triggerMenuContactUs = () => {
  gtmTrack(gtmEvents.MENU_CONTACT_US);
};

export const triggerClickPhoneMenu = () => {
  gtmTrack(gtmEvents.CLICK_PHONE_MENU);
};

export const triggerStayUpdated = (name: string) => {
  gtmTrack(gtmEvents.STAY_UPDATED, { name });
};

export const triggerLeadRequestACallback = (name: string) => {
  gtmTrack(gtmEvents.LEAD_REQUEST_A_CALLBACK, { name });
};

export const triggerLeadFullName = (value: string) => {
  gtmTrack(gtmEvents.LEAD_FULL_NAME, { value });
};

export const triggerLeadFormEmail = (value: string) => {
  gtmTrack(gtmEvents.LEAD_FORM_EMAIL, { value });
};

export const triggerLeadFormPhone = (value: string) => {
  gtmTrack(gtmEvents.LEAD_FORM_PHONE, { value });
};

export const triggerLeadFormComment = (value: string) => {
  gtmTrack(gtmEvents.LEAD_FORM_COMMENT, { value });
};

export const triggerHardwareButtonMid = () => {
  gtmTrack(gtmEvents.HARDWARE_BUTTON_MID);
};

export const triggerSoftwareButtonMid = () => {
  gtmTrack(gtmEvents.SOFTWARE_BUTTON_MID);
};

export const triggerButtonFreeConsultation = () => {
  gtmTrack(gtmEvents.TOP_BUTTON_FREE_CONSULTATION);
};

export const triggerFaq = (name: string, value: string) => {
  gtmTrack(gtmEvents.FAQ, { name, value });
};

export const triggerSelectChargeKwh = (value: string) => {
  gtmTrack(gtmEvents.SELECT_CHARGE_KWH, { value });
};

export const triggerSelectChargeHour = (value: string) => {
  gtmTrack(gtmEvents.SELECT_CHARGE_HOUR, { value });
};

export const triggerSendDataCalculator = (name: string) => {
  gtmTrack(gtmEvents.SEND_DATA_CALCULATOR, { name });
};

export const triggerRebate = (name: string, value: string) => {
  gtmTrack(gtmEvents.REBATE, { name, value });
};

export const triggerPhoneFreeConsultation = (name: string) => {
  gtmTrack(gtmEvents.PHONE_FREE_CONSULTATION, { name });
};

export const triggerEvchargerCallback = (name: string) => {
  gtmTrack(gtmEvents.EVCHARGER_CALLBACK, { name });
};

export const triggerEvchargerRequestCallback = (name: string) => {
  gtmTrack(gtmEvents.EVCHARGER_REQUEST_CALLBACK, { name });
};

export const triggerEvchargerTimeDistance = (name: string, value: string) => {
  gtmTrack(gtmEvents.EVCHARGER_TIME_DISTANCE, { name, value });
};

export const triggerSliderRequestDetails = (name: string) => {
  gtmTrack(gtmEvents.SLIDER_REQUEST_DETAILS, { name });
};
